var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLang(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 7.5C14 11.0899 11.0899 14 7.5 14M14 7.5C14 3.91015 11.0899 1 7.5 1M14 7.5H1M7.5 14C3.91015 14 1 11.0899 1 7.5M7.5 14C8.91418 14 10.0606 11.0899 10.0606 7.5C10.0606 3.91015 8.91418 1 7.5 1M7.5 14C6.08582 14 4.93939 11.0899 4.93939 7.5C4.93939 3.91015 6.08582 1 7.5 1M1 7.5C1 3.91015 3.91015 1 7.5 1",
    stroke: "#212143",
    strokeWidth: 1.20741,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLang);
export default __webpack_public_path__ + "static/media/icon-lang.f1c3fc3dbd67fa9f1ac04133746a423d.svg";
export { ForwardRef as ReactComponent };